import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 15px 30px 0px 30px;

  .MuiDataGrid-row:focus {
    outline: none; /* Remove a borda de foco */
  }

  .green {
    background-color: #b3dab6;
    border-left: 1px solid #31af39;
    border-right: 1px solid #31af39;
  }

  .form-control {
    font-size: 14px;
  }
  .form-control:disabled,
  .form-control[readonly] {
    font-size: 14px;
    color: #a5adba;
    background-color: #e9ecef;
    border: 0;
    cursor: not-allowed;
  }

  .form-control.is-invalid {
    background-image: none;
    border: 2px solid var(--ds-border-neutral, #dfe1e6);
    border-bottom: 2px solid #cf1919;
    &:focus {
      box-shadow: none;
    }
  }
  input {
    border: 2px solid var(--ds-border-neutral, #dfe1e6);
    background-color: #fff;
    font-size: 0.875rem;
    padding: 8px 6px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
      'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;

    &:focus {
      border-color: var(--ds-border-focus, #4c9aff);
      outline: none;
      box-shadow: none;
    }
  }

  @media screen and (max-width: 767px) {
    .containerChild {
      .cancel {
        min-width: 130px;
      }
      .imprimir {
        min-width: 130px;
      }
      .confirm {
        min-width: 130px;
      }
    }
  }
`;

export const ContainerButtCapa = styled.div`
  display: flex;
  flex-direction: columns;
  margin-top: 10px;

  .row {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-left: 5px;

    .colButton {
      min-width: 170px;
      max-width: 170px;
      height: 42px;
    }
    .colButton2 {
      min-width: 170px;
      max-width: 170px;
      height: 42px;
    }
  }

  @media screen and (max-width: 767px) {
    .row {
      flex-direction: row;
      justify-content: space-between;
      margin-left: 0px;

      .colButton {
        min-width: 31%;
        max-width: 31%;
        margin-bottom: 5px;
        padding-right: 0px !important;
        padding-left: 0px !important;
      }
      .colButton2 {
        min-width: 31%;
        max-width: 31%;
        padding-right: 0px !important;
        padding-left: 0px !important;
      }
      .colButton .confirm {
        min-width: 100% !important;
      }
      .colButton .clear {
        min-width: 100% !important;
      }
      .colButton2 .confirm {
        min-width: 100% !important;
      }
    }
  }
`;

export const Title = styled.h3`
  margin-top: 0;
  margin-bottom: 10px;
  color: #313638;
  font-size: calc(1.3rem + 0.6vw);
`;

export const SeparatorLine = styled.p`
  margin: 0px;
  border-bottom: 1px solid #ededed;
  height: 5px;
  width: 99.95%;
`;

export const ContainerButtons = styled.div`
  display: flex;
  width: 100%;
  height: 42px;
  justify-content: flex-end;
  button {
    display: flex;
    gap: 10px;
    min-width: 100px;
    height: 42px;
    align-items: center;
    justify-content: center;
  }
  button: {
    box-shadow: none;
  }

  button.success {
    background-color: #28a745 !important;
    &:disabled {
      background-color: #b7e5c1;
      cursor: not-allowed;
      opacity: 0.7;
      &:hover {
        background-color: #b7e5c1;
        opacity: 1;
      }
    }
  }
`;

export const ContainerPagination = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const TableEmpty = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 60px;
  h3 {
    font-size: 10pt;
    color: var(--ds-text-lowEmphasis, var(--ds-text-lowEmphasis, #6b778c));
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto',
      'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
  }
`;
